module.exports = __webpack_public_path__ + "img/ausstellung3.3017a493.jpg";